import React from 'react';
import ServicesCards from '../homepage-cards/services-cards/ServicesCards';
import { useTranslation } from 'react-i18next';

function HompageThird() {
    const { t, i18n } = useTranslation();
    return (
        <div
            className={`hp hp-third ${i18n.language === 'en' ? 'text-left ' : ''}`}
        >
            <div
                className={`third-statement ${
                    i18n.language === 'en' ? 'left en-third-statement' : ''
                }`}
            >
                <h2>{t('homepage.services.title')}</h2>
                <h5>{t('homepage.services.desc')} </h5>
            </div>
            <div
                className={`services-cards-container ${
                    i18n.language === 'en' ? 'mr-0 en-services-cards-container' : ''
                }`}
            >
                <ServicesCards />
            </div>
        </div>
    );
}

export default HompageThird;
